import React, { createContext, useContext, useState, useCallback } from 'react';

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [options, setOptions] = useState(null);

  const confirm = useCallback((_, message, title, mode = 'custom', actions = []) => {
    return new Promise((resolve) => {
      setOptions({ message, title, mode, actions, resolve });
    });
  }, []);

  const handleClose = (value) => {
    if (options?.resolve) options.resolve(value);
    setOptions(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {options && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded shadow-lg p-6 w-full max-w-md">
            <h2 className="text-lg font-semibold mb-3">{options.title}</h2>
            <p className="mb-4">{options.message}</p>
            <div className="flex justify-center gap-4">
              {options.actions.map((btn, i) => (
                <button
                  key={i}
                  onClick={() => handleClose(btn.value)}
                  className="px-4 py-2 rounded border hover:bg-gray-100"
                >
                  {btn.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
